import { __awaiter, __generator } from "tslib";
import { getLaunchInlineParams } from './getLaunchInlineParams';
import { getLaunchParams } from './getLaunchParams';
import { launchCustomContent } from './launchCustomContent';
/**
 * launchInline attempts to boot a document in the current app
 *
 * Examples of this include the UI Host which will open WXP documents
 * using the JSApi within the Office.com SPA
 * @param contentLaunchParams
 * @param launchInstrumentationParams
 * @returns A promise containing the result of the attempted launch
 */
export function launchInline(contentLaunchParams, launchInstrumentationParams) {
    return __awaiter(this, void 0, void 0, function () {
        var launchParams, launchInlineParams;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getLaunchParams(contentLaunchParams)];
                case 1:
                    launchParams = _a.sent();
                    return [4 /*yield*/, getLaunchInlineParams(contentLaunchParams.document, launchParams.context, launchParams.capabilities)];
                case 2:
                    launchInlineParams = _a.sent();
                    return [2 /*return*/, launchCustomContent(contentLaunchParams, launchInlineParams, launchParams, launchInstrumentationParams)];
            }
        });
    });
}
//# sourceMappingURL=launchInline.js.map